import SectionHeader from '../common/SectionHeader';

function AudienceGrid({ items }) {
  return (
    <section className="service-section service-audience-section">
      <div className="container">
        <SectionHeader
          eyebrow="Users Served"
          title="Who this project serves"
          description="Each operating project is built around a focused audience with practical, repeatable needs."
          align="center"
        />
        <div className="service-audience-grid">
          {items.map((item) => (
            <article className="service-audience-card" key={item}>
              <span>{item}</span>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}

export default AudienceGrid;
